export const languages = [
  { code: 'en', name: 'English', flag: '🇺🇸', englishName: 'English' },
  { code: 'uk', name: 'Українська', flag: '🇺🇦', englishName: 'Ukrainian' },
  { code: 'be', name: 'Беларуская', flag: '🇧🇾', englishName: 'Belarusian' },
  { code: 'es', name: 'Español', flag: '🇪🇸', englishName: 'Spanish' },
  { code: 'fr', name: 'Français', flag: '🇫🇷', englishName: 'French' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪', englishName: 'German' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹', englishName: 'Italian' },
  { code: 'pt', name: 'Português', flag: '🇵🇹', englishName: 'Portuguese' },
  { code: 'pl', name: 'Polski', flag: '🇵🇱', englishName: 'Polish' },
  { code: 'ro', name: 'Română', flag: '🇷🇴', englishName: 'Romanian' },
  { code: 'nl', name: 'Nederlands', flag: '🇳🇱', englishName: 'Dutch' },
  { code: 'sv', name: 'Svenska', flag: '🇸🇪', englishName: 'Swedish' },
  { code: 'da', name: 'Dansk', flag: '🇩🇰', englishName: 'Danish' },
  { code: 'fi', name: 'Suomi', flag: '🇫🇮', englishName: 'Finnish' },
  { code: 'no', name: 'Norsk', flag: '🇳🇴', englishName: 'Norwegian' },
  { code: 'cs', name: 'Čeština', flag: '🇨🇿', englishName: 'Czech' },
  { code: 'sk', name: 'Slovenčina', flag: '🇸🇰', englishName: 'Slovak' },
  { code: 'sl', name: 'Slovenščina', flag: '🇸🇮', englishName: 'Slovenian' },
  { code: 'hu', name: 'Magyar', flag: '🇭🇺', englishName: 'Hungarian' },
  { code: 'el', name: 'Ελληνικά', flag: '🇬🇷', englishName: 'Greek' },
  { code: 'bg', name: 'Български', flag: '🇧🇬', englishName: 'Bulgarian' },
  { code: 'hr', name: 'Hrvatski', flag: '🇭🇷', englishName: 'Croatian' },
  { code: 'lt', name: 'Lietuvių', flag: '🇱🇹', englishName: 'Lithuanian' },
  { code: 'lv', name: 'Latviešu', flag: '🇱🇻', englishName: 'Latvian' },
  { code: 'et', name: 'Eesti', flag: '🇪🇪', englishName: 'Estonian' },
  { code: 'mk', name: 'Македонски', flag: '🇲🇰', englishName: 'Macedonian' },
  { code: 'sr', name: 'Српски', flag: '🇷🇸', englishName: 'Serbian' },
  { code: 'tr', name: 'Türkçe', flag: '🇹🇷', englishName: 'Turkish' },
  { code: 'ka', name: 'ქართული', flag: '🇬🇪', englishName: 'Georgian' },
  {
    code: 'az',
    name: 'Azərbaycan dili',
    flag: '🇦🇿',
    englishName: 'Azerbaijani'
  },
  { code: 'kk', name: 'Қазақ тілі', flag: '🇰🇿', englishName: 'Kazakh' },
  { code: 'hy', name: 'Հայերեն', flag: '🇦🇲', englishName: 'Armenian' },
  { code: 'ar', name: 'العربية', flag: '🇸🇦', englishName: 'Arabic' },
  { code: 'zh', name: '中文', flag: '🇨🇳', englishName: 'Chinese' },
  { code: 'hi', name: 'हिन्दी', flag: '🇮🇳', englishName: 'Hindi' },
  { code: 'ja', name: '日本語', flag: '🇯🇵', englishName: 'Japanese' },
  { code: 'ko', name: '한국어', flag: '🇰🇷', englishName: 'Korean' },
  { code: 'vi', name: 'Tiếng Việt', flag: '🇻🇳', englishName: 'Vietnamese' },
  {
    code: 'id',
    name: 'Bahasa Indonesia',
    flag: '🇮🇩',
    englishName: 'Indonesian'
  }
]
